import { render, staticRenderFns } from "./BillView.vue?vue&type=template&id=f4d3d42a&scoped=true"
import script from "./BillView.vue?vue&type=script&lang=js"
export * from "./BillView.vue?vue&type=script&lang=js"
import style0 from "./BillView.vue?vue&type=style&index=0&id=f4d3d42a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d3d42a",
  null
  
)

export default component.exports